import { gql } from '@apollo/client';

const query = gql`
  query getGlossVersion {
    version
  }
`;

export default query;
